const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  GET_MOBILE_INSURANCE_BEGINS: 'MOBILE_INSURANCE/GET_MOBILE_INSURANCE_BEGINS',
  GET_MOBILE_INSURANCE_SUCCESS: 'MOBILE_INSURANCE/GET_MOBILE_INSURANCE_SUCCESS',
  GET_MOBILE_INSURANCE_ERROR: 'MOBILE_INSURANCE/GET_MOBILE_INSURANCE_ERROR',
  GET_MOBILE_INSURANCE_LEGALS_BEGINS:
    'MOBILE_INSURANCE/GET_MOBILE_INSURANCE_LEGALS_BEGINS',
  GET_MOBILE_INSURANCE_LEGALS_SUCCESS:
    'MOBILE_INSURANCE/GET_MOBILE_INSURANCE_LEGALS_SUCCESS',
  SET_TYPE_BUY_PROCESS: 'MOBILE_INSURANCE/SET_TYPE_BUY_PROCESS',
};

export const initialState = {
  mobileInsuranceInfo: null,
  mobileInsuranceInfoFetching: false,
  mobileInsuranceInfoError: false,
  mobileInsuranceLegalsInfo: null,
  typeBuyProcess: null,
};

const MobileInsuranceReducer = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE: {
      let { mobileInsuranceReducer } = action.payload;
      return {
        ...mobileInsuranceReducer,
        ...state,
      }
    }
    case types.GET_MOBILE_INSURANCE_BEGINS:
      return {
        ...state,
        mobileInsuranceInfo: null,
        mobileInsuranceInfo: null,
        mobileInsuranceInfoFetching: true,
      };
    case types.GET_MOBILE_INSURANCE_SUCCESS: {
      return {
        ...state,
        mobileInsuranceInfo: action.payload,
        mobileInsuranceInfoFetching: false,
      };
    }
    case types.GET_MOBILE_INSURANCE_ERROR: {
      return {
        ...state,
        mobileInsuranceInfoFetching: false,
        mobileInsuranceInfoError: true,
      }
    }
    case types.GET_MOBILE_INSURANCE_LEGALS_BEGINS:
      return {
        ...state,
        mobileInsuranceLegalsInfo: null,
      };
    case types.GET_MOBILE_INSURANCE_LEGALS_SUCCESS: {
      return {
        ...state,
        mobileInsuranceLegalsInfo: action.payload,
      };
    }
    case types.SET_TYPE_BUY_PROCESS: {
      return {
        ...state,
        typeBuyProcess: action.payload,
      };
    }
    default:
      return state;
  }
};

export const actions = {
  getMobileInsurance: (data) => ({
    type: types.GET_MOBILE_INSURANCE_BEGINS,
    data,
  }),
  getMobileInsuranceSuccess: (data) => ({
    type: types.GET_MOBILE_INSURANCE_SUCCESS,
    payload: data,
  }),
  getMobileInsuranceError: () => ({
    type: types.GET_MOBILE_INSURANCE_ERROR,
  }),
  getMobileInsuranceLegals: (data) => ({
    type: types.GET_MOBILE_INSURANCE_LEGALS_BEGINS,
    data,
  }),
  getMobileInsuranceLegalsSuccess: (data) => ({
    type: types.GET_MOBILE_INSURANCE_LEGALS_SUCCESS,
    payload: data,
  }),
  setBuyProcessType: (type) => ({
    type: types.SET_TYPE_BUY_PROCESS,
    payload: type,
  }),
};

export default MobileInsuranceReducer;
